import "antd/dist/antd.css";
import React, { useState, useEffect, useReducer } from "react";
import { Row, Col, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { initialState, reducer } from "./reducer";
import { useSelector } from "react-redux";
import Search from "./components/Search";
import List from "./components/List";
import VoterService from "../../../../../services/Patronage/VoterService";



const setRowNumber = (items) => {
    if (items) {
        let counter = 0;
        const updatedItems = items.map((elm) => {
            counter += 1;
            return {
                ...elm,
                row_number: counter,
                index: counter
            };
        });

        return updatedItems;
    }
    return items;
};



const VotersList = ({ voter, updateVoter, onClose }) => {
    const token = useSelector((state) => state.Member.token);
    const [state, dispatch] = useReducer(reducer, initialState);
    const [errorMessage, setErrorMessage] = useState(null);


    const onModalClose = () => {
        updateVoter(null);
        onClose();
    };


    const onConfirm = () => {
        onClose();
    };


    useEffect(() => {
        if (state.filters.searchFilters?.name) {
            updateLoading(true);
            VoterService.getSimpleList(token, state.filters)
                .then((response) => {
                    const itemsList = setRowNumber(response.data);
                    const items = itemsList?.map((elm) => {
                        if (elm?.id === voter?.id) {
                            return {
                                ...elm,
                                isSelected: true,
                            }
                        } else {
                            return {
                                ...elm,
                                isSelected: false,
                            }
                        }
                    });
                    const totalCount = items.length;
                    const action = {
                        type: "set_items",
                        payload: {
                            items: items,
                            total: totalCount,
                        },
                    };
                    dispatch(action);
                    setErrorMessage(null);
                    updateLoading(false);
                })
                .catch((err) => {
                    setErrorMessage("Një gabim ndodhi gjatë komunikimit me serverin!");
                    updateLoading(false);
                });
        } else {
            setErrorMessage("Ju lutem, kërkoni me emër dhe mbiemër!");
        }
    }, [token, state.filters, voter]);


    const updateLoading = (isLoading) => {
        const action = {
            type: "set_loading",
            payload: isLoading,
        };
        dispatch(action);
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24}>
                    <Col span={24}>
                        <Search
                            dispatch={dispatch}
                            initialFilters={state.filters.searchFilters}
                            pagination={state.filters.pagination}
                            loading={state.isLoading}
                        />
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <List
                            dispatch={dispatch}
                            items={state.items}
                            updateVoter={updateVoter}
                            isLoading={state.isLoading}
                            errorMessage={errorMessage}
                            onChoose={onConfirm}
                        />
                    </Col>
                </Row>
                <Row gutter={24} className="mt-5">
                    <Col span={24} className="text-center">
                        {/* <Button
                            type="primary"
                            style={{ width: "120px" }}
                            disabled={voter === null}
                            icon={<CheckOutlined />}
                            onClick={onConfirm}
                        >
                            Konfirmo
                        </Button> */}
                        <Button
                            danger
                            className="ml-4"
                            style={{ width: "120px" }}
                            icon={<CloseOutlined />}
                            onClick={onModalClose}
                        >
                            Mbyll
                        </Button>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default VotersList;